/**
 * Google Analytics 4 — SPA-aware page_view tracking.
 *
 * gtag.js is loaded from public/index.html with `send_page_view: false`, so this
 * hook is the single source of truth for firing a `page_view` on each client-side
 * route change (react-router). The GA4 debug view will then show every visited
 * pathname/search rather than only the initial full page load.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function useAnalytics() {
  const location = useLocation();
  useEffect(() => {
    if (!MEASUREMENT_ID) return;
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const page_path = location.pathname + location.search + location.hash;
    const page_title = document.title || "";
    // Redact any OAuth token from the URL before sending it to GA.
    const safe_path = page_path.replace(/session_id=[^&#]*/i, "session_id=REDACTED");
    window.gtag("event", "page_view", {
      page_path: safe_path,
      page_location: window.location.origin + safe_path,
      page_title,
      send_to: MEASUREMENT_ID,
    });
  }, [location.pathname, location.search, location.hash]);
}
